var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manage-var"},[_c('h1',[_vm._v("Manage Value-added Resalers")]),_vm._v(" "),_c('ConferVAR'),_vm._v(" "),_c('div',{staticClass:"var-list"},_vm._l((_vm.vars),function(user){return _c('ValueAddedResalerSelect',{key:user.id,attrs:{"user":user}})}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f22079a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManageValueAddedResalers.vue
// module id = null
// module chunks = 